
import { AbstractControl, ValidationErrors } from '@angular/forms';

export class Utils {
  static CPF_CNPJ_REGEX: RegExp = /^(\d{11}|\d{14})$|^(\d{3}\.\d{3}\.\d{3}-\d{2}|\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2})$/;
  static toBase64(file: File): Promise<string | ArrayBuffer> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        if (reader.result !== null) {
          resolve(reader.result);
        } else {
          reject(new Error('Falha ao converter o arquivo para Base64'));
        }
      };
      reader.onerror = error => reject(error);
    });
  }

  static isMobile() {
    return window && window.matchMedia('(max-width: 768px)').matches;
  }

  static mountPageControl(pageControl: any): string {
    let result = '';

    if (!pageControl) {
      return result;
    }

    Object.entries(pageControl).forEach(([key, value]) => {
      result += `${key}=${value}&`;
    });

    return result;
  }

  static filterAutocomplete(
    items: any,
    value: any,
    field = 'name',
    field2 = ''
  ) {
    if (typeof value === 'string' && items.length) {
      const filterValue = value
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');
      return items.filter((option: any) => {
        return (
          filterValue === '' ||
          String(field2 ? option[field][field2] : option[field])
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .includes(filterValue)
        );
      });
    }
  }

  static capitalizeCase(str: string): string {
    let result: string = '';

    str.split(' ').forEach((word, index) => {
      if (index) {
        result += ` ${word[0].toUpperCase()}${word.substring(1).toLowerCase()}`;
        return;
      }
      result += `${word[0].toUpperCase()}${word.substring(1).toLowerCase()}`;
    });

    return result;
  }

  static routerBack(): void {
    window.history.back();
  }

  static senhaForteValidator(control: AbstractControl): ValidationErrors | null {
    const senha = control.value;

    if (!senha) return null;

    const requisitos = [
      senha.length >= 8,
      /[A-Z]/.test(senha),
      /[a-z]/.test(senha),
      /\d/.test(senha),
      /[\W_]/.test(senha)
    ];

    const valido = requisitos.every(r => r);

    return valido ? null : { senhaFraca: true };
  }

}
